import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Link from 'react-router/Link';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Login from './Login';
import './FrontPage.css';

class GuestLayout extends Component {

  constructor() {
    super();

    this.state = { open: false };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onTouchTap={this.handleClose}
      />,
    ];

    const style = {
      maxWidth: '500px',
      margin: 'auto',
    };

    const registerClass = window.location.pathname === '/' ? 'is-front' : '';

    return (
      <div>
        <div className={`pronounce-front ${this.props.classes} ${registerClass}`}>
          <div id="pronounce-front-page">
          {window.location.pathname !== '/create-account-android' &&  <div className="pronounce-front-header">
              {window.location.pathname !== '/' && (<Link to="/" ><img alt="Pronounce Live" role="presentation" src="/PL-logotest.png" width="200" /></Link>)}
              {window.location.pathname === '/' && (<span />)}
              <span>
                <Link id="register" to="/register">Have a group token? Register your account here</Link>
                <RaisedButton className="login-btn" id="login" label="Login" onTouchTap={this.handleOpen} />

            </span>
              <Dialog
                contentStyle={style}
                title=""
                actions={actions}
                modal={false}
                autoScrollBodyContent={true}
                open={this.state.open}
                onRequestClose={this.handleClose}
              >
                <Login {...this.props} handleClose={this.handleClose} />
              </Dialog>
            </div>}
            <ReactCSSTransitionGroup
              transitionName="example"
              transitionEnterTimeout={2500}
              transitionLeaveTimeout={2300}
            >
              {this.props.children}
            </ReactCSSTransitionGroup>
          </div>
        </div>
      </div>
    );
  }

}

export default GuestLayout;



// WEBPACK FOOTER //
// ./src/components/GuestLayout.js